import { Modal, ModalContent } from '@chakra-ui/react';
import { StandardSnack } from '@sketch-note/design-system/src/components/snackbar';
import { CustomEmailIcon, ErrorIcon } from '@sketchnote/icons';
import cn from 'classnames';
import React, { useRef, useState } from 'react';
import { useTableStore } from 'src/features/list/store';
import { Task } from 'src/features/tasks/types/tasks';

export const EmailFieldCell = ({
  task,
  fieldId,
  data,
  api,
}: {
  task: Partial<Task>;
  fieldId: string;
  data: string;
  api: any;
}): JSX.Element => {
  const [fieldData, setFieldData] = useState(typeof data === 'string' ? data : '');
  const [isFocused, setIsFocused] = useState(false);
  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
  const { isReadOnly } = useTableStore();

  const onUpdateCustomFieldData = useTableStore((s) => s.onUpdateCustomFieldData);

  const handleErrorModal = () => {
    setErrorModalIsOpen(false);
    setIsFocused(true);
  };
  const testEmail = (inputStr): boolean => {
    if (inputStr === '') return true;
    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailPattern.test(inputStr);
  };

  return (
    <div className="flex rounded-sm items-center">
      <input
        disabled={isReadOnly}
        type="text"
        pattern="[^ @]*@[^ @]*"
        className={cn(
          'text-sm text-gray-999 font-regular placeholder-gray-500 bg-transparent h-36 w-full pl-15',
          {
            'bg-white': isFocused,
          }
        )}
        onChange={(e) => {
          setFieldData(e.target.value);
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            if (testEmail(fieldData)) {
              // setFieldData(fieldData);
              setIsFocused(false);
              task.id && onUpdateCustomFieldData(task, fieldId, fieldData);
            } else {
              setFieldData('');
              setErrorModalIsOpen(true);
            }
          }
        }}
        onFocus={(e) => {
          setIsFocused(true);
        }}
        onBlur={(e) => {
          if (testEmail(fieldData)) {
            setIsFocused(false);
            task.id && onUpdateCustomFieldData(task, fieldId, fieldData);
          } else {
            setFieldData('');
            setErrorModalIsOpen(true);
            setIsFocused(false);
          }
        }}
        value={fieldData}
        placeholder="Enter email"
      />
      <Modal isOpen={errorModalIsOpen} onClose={handleErrorModal}>
        <ModalContent style={{ width: '40rem', borderRadius: '10px', marginTop: '65rem' }}>
          <StandardSnack icon={<ErrorIcon />} text="Enter valid email" />
        </ModalContent>
      </Modal>
    </div>
  );
};
